import { Routes } from '@angular/router';
import {authRoutes, AuthRoutingModule} from "./auth/auth-routing.module";
import {dashboardRoutes} from "./dashboard/dashboard-routing.module";

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  ...authRoutes,
  ...dashboardRoutes,
];
